"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Caption = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)(_mui.Box)(({
  theme
}) => ({
  padding: theme.spacing(0, 3, 6),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(0, 6, 6)
  }
}));
const Caption = exports.Caption = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.text.secondary,
  fontSize: '1.2rem',
  fontWeight: theme.typography.fontWeightBold,
  lineHeight: 1.5,
  letterSpacing: '2.4px',
  textTransform: 'uppercase'
}));
